<template>
  <div class="account">
    <div class="account__nav">
      <AccountNav />
    </div>
    <div class="account__view">
      <Settings v-if="$route.name == 'account'" />
      <Favorites v-if="$route.name == 'favorites'" />
    </div>
  </div>
</template>

<script>
import AccountNav from "@/components/account/AccountNav.vue";
import Settings from "@/views/account/Settings.vue";
import Favorites from "@/views/account/Favorites.vue";
export default {
  components: { Settings, Favorites, AccountNav },
  data() {
    return {
      recipes: [],
      currentRoute: null,
      pageTitle: "Mon Compte"
    };
  },
  watch: {
    $route() {
      this.setPageTitle();
    }
  },
  created() {
    this.setPageTitle();
  },
  methods: {
    setPageTitle() {
      this.currentRoute = this.$route;
      if (this.currentRoute.name === "favorites") {
        this.pageTitle = "Mes Favoris";
      } else {
        this.pageTitle = "Mon Compte";
      }
    }
  }
};
</script>
